import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/Home/index.vue';

import searchRankingsRouter from './modules/searchRankings';
import QuotationListRouter from './modules/QuotationList';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    // component: { template: '<div>Home Page Working!</div>' },
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Login/index.vue'),
  },
  {
    path: '/search',
    name: 'search',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Search/index.vue'),
  },
  {
    path: '/goods',
    name: 'goods',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Goods/index.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/register/index.vue'),
  },
  {
    path: '/ymxsalesVolume',
    name: 'ymxsalesVolume',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/YMXsalesVolume/index.vue'
      ),
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/welcome/welcome.vue'),
  },
  {
    path: '/shop_list',
    name: 'shop_list',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/shop_list/index.vue'),
  },
  {
    path: '/cart',
    name: 'cart',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/cart/index.vue'),
  },
  {
    path: '/404',
    component: () => import('../views/errorPage/404.vue'),
    hidden: true,
  },
  searchRankingsRouter,
  QuotationListRouter,
  // Vue Router 4 新的捕获所有路由语法
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    hidden: true,
  },
];

const router = createRouter({
  // process.env.BASE_URL
  // process.env.BASE_URL
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});
console.log('BASE_URL:', process.env.BASE_URL || import.meta.env.BASE_URL);
export default router;
